import { Alert, Link, Stack, Typography } from "@mui/joy";
import TenantScopeSwitcher from "./TenantScopeSwitcher";

export type RefusalScreen = "no_access" | "lost_access" | "not_found" | "disabled";

const TITLES: Record<RefusalScreen, string> = {
    no_access: "You don't have access to this project.",
    lost_access: "You no longer have access to this project.",
    not_found: "We couldn't find that project.",
    disabled: "This project's link is turned off for now.",
};

function differentAccountHref(): string {
    const { pathname, search, hash } = window.location;
    return `/authenticate?company_auth=required&redirect=${encodeURIComponent(pathname + search + hash)}`;
}

/** A refusal that retrying cannot change: say so, and offer the projects they can open. */
export default function AdmissionRefusal({ screen }: { screen: RefusalScreen }) {
    // Only an access refusal is about this person; another account or an admin can change it.
    const accessRefused = screen === "no_access" || screen === "lost_access";
    return (
        <Stack spacing={2}>
            <Alert color="warning">{TITLES[screen]}</Alert>
            {accessRefused && <Typography>Ask a project admin to add you.</Typography>}
            <TenantScopeSwitcher color="neutral" />
            {accessRefused && (
                <Link href={differentAccountHref()}>Sign in with a different account</Link>
            )}
        </Stack>
    );
}
